export const BroadcastIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00017 14.6668H10.0002C13.3335 14.6668 14.6669 13.3335 14.6669 10.0002V6.00017C14.6669 2.66683 13.3335 1.3335 10.0002 1.3335H6.00017C2.66683 1.3335 1.3335 2.66683 1.3335 6.00017V10.0002C1.3335 13.3335 2.66683 14.6668 6.00017 14.6668Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8931 4.68983C11.0123 4.64667 11.1462 4.66397 11.2501 4.73705C11.354 4.80951 11.4166 4.9291 11.4166 5.05645V10.5215C11.4166 10.6487 11.354 10.7677 11.2501 10.8409C11.1462 10.914 11.0124 10.932 10.8931 10.8881L6.66326 9.35032H6.07889L6.71769 11.5853L5.96682 11.7998L5.26719 9.35032H4.39064C4.17558 9.35032 4.00017 9.17551 4 8.96048V6.61822C4 6.40233 4.17547 6.22758 4.39064 6.22758H6.66326L10.8931 4.68983ZM7.12354 6.89119V8.68671L10.6361 9.96431V5.6136L7.12354 6.89119ZM4.78129 8.56904H6.34226V7.00807H4.78129V8.56904Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  )
}
